import { OrderStatus } from '@customer-apps/shared/enums';
import { EnumDictionary } from '@customer-apps/shared/utils';

export const orderStatusDictionary: EnumDictionary<OrderStatus, string> = {
    [OrderStatus.Completed]: 'ORDER_STATUS.COMPLETED',
    [OrderStatus.Created]: 'ORDER_STATUS.CREATED',
    [OrderStatus.Processing]: 'ORDER_STATUS.PROCESSING',
    [OrderStatus.Rejected]: 'ORDER_STATUS.REJECTED'
};
